export const env = 'prod'; // updateid

export const REDIRECT_URLS = {
  dev: 'https://local.backlotclub.com',
  stage: 'https://epic-universe-stage.backlot.club',
  uat: 'https://epic-universe-uat.backlot.club',
  prod: 'https://epic-universe.backlot.club',
  alt: 'https://epic-universe.backclub.com'
};
